import { render, staticRenderFns } from "./TheProductListHeader.vue?vue&type=template&id=342ba8f4&"
import script from "./TheProductListHeader.vue?vue&type=script&lang=js&"
export * from "./TheProductListHeader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../sfra-webpack-builder/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/atlassian/pipelines/agent/build/sfra-webpack-builder/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('342ba8f4')) {
      api.createRecord('342ba8f4', component.options)
    } else {
      api.reload('342ba8f4', component.options)
    }
    module.hot.accept("./TheProductListHeader.vue?vue&type=template&id=342ba8f4&", function () {
      api.rerender('342ba8f4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "app_byl_core/cartridges/app_byl_core/cartridge/client/default/js/vue/components/TheProductListHeader.vue"
export default component.exports